import { useMemo } from "react"

import {
  ContentTag,
  isInPlaceEditingActive,
  provideComponent,
  useDataItem
} from "scrivito"
import { Opportunity } from "scrivito/Data/Opportunity/OpportunityDataClass"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"

import { ProjectOpportunityWidget } from "./ProjectOpportunityWidgetClass"

provideComponent(
  ProjectOpportunityWidget,
  ({ widget }) => {
    const project = useDataItem("Project")
    const sharedProject = useDataItem("SharedProject")

    const projectID =
      project?.get("projectId") || sharedProject?.get("projectId")

    const scope = Opportunity.all().transform({
      search: `external_id=${projectID}`
    })
    const opportunity = useMemo(() => scope?.take()[0], [scope, projectID])

    const showEmptyContent = !opportunity || isInPlaceEditingActive()

    return (
      <>
        {showEmptyContent ? (
          <ContentTag content={widget} attribute="emptyContent" />
        ) : null}
        {opportunity ? (
          <ContentTag
            content={widget}
            attribute="content"
            dataContext={opportunity}
          />
        ) : null}
      </>
    )
  },
  { loading: () => <LoadingSpinner /> }
)
